import ShareholderAnalysisTop10Sectors from './ShareholderAnalysisTop10Sectors';

export default ShareholderAnalysisTop10Sectors;

